<script setup lang="ts">
import {
  getQuestionStatusName,
  getQuestionTypeName,
  type Question,
} from '../calendarQuestion'

const { question } = defineProps<{
  question: Question
}>()

const statusName = getQuestionStatusName(question.status)

const typeName = getQuestionTypeName(question.type)
</script>
<template>
  <section :class="$style.question">
    <div :class="$style.questionTitle">
      質問:
      <span :class="$style.questionTitle__text">{{
        question.questionText
      }}</span>
    </div>
    <div :class="$style.type">
      タイプ:
      <span :class="$style.type__text">{{ typeName }}</span>
    </div>
    <div :class="$style.status">
      必須設定:
      <span :class="$style.status__text">{{ statusName }}</span>
    </div>
    <div v-if="question.type === 'SELECT_BOX'" :class="$style.selectBoxOptions">
      選択肢:
      <template v-for="(option, index) in question.options" :key="index">
        {{ index > 0 ? ', ' : '' }}
        <span :class="$style.selectBoxOptions__option">
          {{ option }}
        </span>
      </template>
      (計{{ question.options.length }}個)
    </div>
  </section>
</template>

<style lang="scss" module>
.question {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.questionTitle {
  font-weight: bold;
  color: $color-text-and-object-medium-emphasis;

  &__text {
    color: $color-text-and-object-high-emphasis;
  }
}

.type {
  color: $color-text-and-object-medium-emphasis;

  &__text {
    color: $color-text-and-object-high-emphasis;
  }
}

.status {
  color: $color-text-and-object-medium-emphasis;

  &__text {
    color: $color-text-and-object-high-emphasis;
  }
}

.selectBoxOptions {
  color: $color-text-and-object-medium-emphasis;

  &__option {
    color: $color-text-and-object-high-emphasis;
  }
}
</style>
